<template>
        <div>
            <transition name="fade" mode="out-in">
                <router-view></router-view>
            </transition>
        </div>
</template>

<script>

    export default {
        mounted(){
            // Get current language (determined by url)
            let lang = "de"
            // Set Translation locale
            this.$i18n.locale = lang
            // Load Content and Data from Backend
            this.$store.dispatch('fetchData', {
                lang
            })
        },
        updated(){
            // Get current language (determined by url)
            let lang = "de"
            // Set Translation locale
            this.$i18n.locale = lang
            // Load Content and Data from Backend
            this.$store.dispatch('fetchData', {
                lang
            })
        }

    }
</script>

<style scoped lang="scss">
    main {
        padding: 60px 50px 80px 50px;
        min-height: calc(100vh - 390px);
    }

    .fade-enter-active, .fade-leave-active {
        opacity: 1;
        transition: opacity .4s ease;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
    @media (max-width: 1000px){
        main {
            padding: 175px 50px 80px 50px;
        }
    }
    @media (max-width: 500px) {
        main {
            padding: 175px 25px 80px 25px;
        }
    }
</style>
